import { z } from 'zod'

export const CRM_MSGRAPH_INTAKE_CONTRACT_VERSION = '1.0.0' as const

export const crmMsGraphIntakeResponseSchema = z.object({
  contract_version: z.literal(CRM_MSGRAPH_INTAKE_CONTRACT_VERSION),
  intake: z.object({
    orgId: z.string(),
    synced: z.boolean(),
    reason: z.string().nullable(),
    fetched: z.number(),
    inserted: z.number(),
    replayed: z.number(),
    matched: z.number(),
  }).passthrough(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export type CrmMsGraphIntakeResponse = z.infer<typeof crmMsGraphIntakeResponseSchema>
